import img from '../../helpers/img';

export default {
  title: 'EDMCake',
  tile: {
    grid: 'col-12 lap-6',
    bgImage: img('edmcake/edmcake-hero.jpg')
  },
  hero: {
    bgImage: img('edmcake/edmcake-hero.jpg'),
    bgPosition: 'top'
  },
  info: {
    client: 'EDMCake',
    timeline: '2013 - 2014',
    description: [
      'EDMCake is an iOS app that streams EDM mixes aggregated from podcasts, live events, and RSS feeds.'
    ],
    tools: `
      Titanium Appcelerator,
      Node,
      HTML5,
      RSS
    `,
    buttons: []
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('edmcake/edmcake-hero.jpg'),
      caption: 'EDMCake Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('edmcake/edmcake-dashboard.jpg'),
      caption: 'EDMCake Dashboard'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('edmcake/edmcake-playlist.jpg'),
      caption: 'EDMCake Playlist'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('edmcake/edmcake-player.jpg'),
      caption: 'EDMCake Player'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/edmcake.js